import { Select } from "@mui/material";

export function FormSelect({ formik, name, value, label, size = "large", margin = "dense", children, ...prors }) {
    return (
        <Select
            size={size}
            fullWidth
            margin={margin}
            id={name}
            name={name}
            label={label}
            value={value}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            {...prors}
        >
            {children}
        </Select>

    )
}